const { createApp } = Vue;

createApp({
    data() {
        return {
            // Global Modal state
            showGlobalModal: false,
            globalModalContent: '',
            // Banner state
            showBanner: true,
            bannerContent: '<strong>New Hanover County, North Carolina.</strong><br />Zoom in to select a parcel or use the search bar to get started.',
            bannerHidden: false,
            isMeasuringCollapsed: true,
            isPolygonDrawing: false,
            isLineDrawing: false,
            showLineDrawingAlert: false,
            showPolygonDrawingAlert: false,
            lineDrawingAlertMessage: window.innerWidth <= 576
                ? 'Tap once to start, then tap again to set the end point.'
                : 'Click once to start, then double-click to set the end point.',
            polygonDrawingAlertMessage: window.innerWidth <= 576
                ? 'Tap the map to add points. Tap Finish when finished.'
                : 'Click the map to add points. Double click when finished.',
            isMobile: window.innerWidth <= 576,
            searchAddress: '',
            searchDebounceTimer: null,
            searchResults: [],
            usesSearchTerm: '',
            usesResults: [],
            usesSearchTimer: null,
            usesLoading: false,
            usesChecked: {},
            selectedUseCategory: '',
            activeFilteredUses: [],
            useStatusFilters: {
                PBR: true,  // Permitted by Right - default checked
                PWS: true,  // Permitted with Supplemental Standards - default checked
                SUP: false, // Special Use Permit Required
                SUPS: false, // Special Use Permit + Supplemental Standards
                CZ: false   // Conditional Zoning Required
            },
            // Auth state
            isAuthenticated: false, // Track authentication status
            // Auth / registration overlay state
            showRegistrationOverlay: false,
            authMode: 'login',
            authMessage: '',
            authAlertVariant: 'danger',
            authState: 'login', // login | register | success
            authEmail: '',
            otpCode: '',
            authLoading: false,
            // Registration form data
            registerEmail: '',
            registerFirstName: '',
            registerLastName: '',
            registerProfession: '',
            showTermsOfUse: false,
            termsAccepted: false,
            isSelectingAddress: false,
            showInspectionPanel: false,
            showParcelDetailsButton: false,
            pendingParcelData: null,
            pendingParcelAddress: null,
            pendingParcelRecords: [],
            parcelDetails: {
                acres: null,
                pid: null,
                zoningDistrict: null,
                totalFrontageFeet: null,
                areaSquareFeet: null,
                latitude: null,
                longitude: null
            },
            floodZoneData: null,
            wetlandData: null,
            wetlandDetailsExpanded: {},
            soilData: null,
            showTerrain3D: false,
            inspectionAddress: null,
            parcelRecords: [],
            selectedParcelIndex: 0,
            parcelSideInfo: null,
            parcelBoundaryCoordinates: null,
            inspectionActiveTab: 'parcel',
            tabsCanScroll: false,
            tabsScrolledToEnd: false,
            showChatPanel: false,
            remainingChats: null, // null = not loaded, number = remaining chats
            chatInput: '',
            chatMaxLength: 1000,
            chatResponse: null,
            chatStatus: '',
            chatLoading: false,
            showParcelSummaryPanel: false,
            parcelSummaryData: null,
            parcelSummaryLoading: false,
            permittedUses: {
                permittedByRight: [],
                permittedWithSupplemental: [],
                specialUsePermit: [],
                specialUsePermitSupplemental: [],
                conditionalZoning: [],
                conditionalZoningSupplemental: []
            },
            permittedResidentialTags: {
                singleFamily: { allowsSingleFamily: false, permissionClass: '', supplementalRegulation: null },
                duplex: { allowsDuplex: false, permissionClass: '', supplementalRegulation: null },
                triplex: { allowsTriplex: false, permissionClass: '', supplementalRegulation: null },
                adu: { allowsAdu: false, permissionClass: '', supplementalRegulation: null },
                commercial: { allowsCommercial: false, permissionClass: '', supplementalRegulation: null }
            },
            permittedUsesLoading: false,
            setbacks: {
                front: [],
                side: [],
                rear: [],
                corner: []
            },
            setbacksLoading: false,
            showMoreSetbacks: false,
            devStandards: {},
            devStandardsLoading: false,
            isZoningTreeCollapsed: true,
            isFloodMapCollapsed: true,
            floodLayerEnabled: false,
            wetlandsLayerEnabled: false,
            isSatelliteMode: false,
            municipalities: [
                { id: 1, name: 'Wilmington', collapsed: true, zoningCollapsed: true, usesCollapsed: true, zones: ['AI', 'CB', 'CBD', 'CEM', 'CS', 'G-1', 'HD', 'HD-MU', 'HD-R', 'IND', 'LI', 'MD-10', 'MD-17', 'MF-H', 'MF-L', 'MF-MH', 'MH', 'MHP', 'MX', 'O&I', 'O&I-1', 'R-10', 'R-15', 'R-20', 'R-3', 'R-5', 'R-7', 'RB', 'ROD', 'UMX'] },
                { id: 2, name: 'Carolina Beach', collapsed: true, zoningCollapsed: true, usesCollapsed: true, zones: ['C', 'CBD', 'HB', 'I-1', 'MB-1', 'MF', 'MH', 'MX', 'NB', 'R-1', 'R-1B', 'R-2', 'R-3', 'T-1'] },
                { id: 3, name: 'Wrightsville Beach', collapsed: true, zoningCollapsed: true, usesCollapsed: true, zones: ['C-1', 'C-2', 'C-3', 'C-4', 'C-5', 'G-1', 'P-1', 'PC', 'R-1', 'R-2', 'R-3', 'S-1', 'UMX'] },
                { id: 4, name: 'Kure Beach', collapsed: true, zoningCollapsed: true, usesCollapsed: true, zones: ['B-1', 'B-2', 'B-3', 'B-4', 'RA-1A', 'RA-2', 'RA-2A', 'RA-2T', 'RA-3', 'RA-3A', 'RA-4', 'RB-1'] },
                { id: 5, name: 'New Hanover County', collapsed: true, zoningCollapsed: true, usesCollapsed: true, zones: ['AC', 'AI', 'AR', 'B-1', 'B-2', 'C', 'CB', 'CBD', 'CDZ', 'CS', 'EDZD', 'HD-MU', 'I-1', 'I-2', 'MF-L', 'O&I', 'PD', 'R-1', 'R-10', 'R-15', 'R-20', 'R-20S', 'R-5', 'R-7', 'RA', 'RA-1A', 'RA-4', 'RFMU', 'RMF-L', 'RMF-M', 'SC', 'UMX'] }
            ],
            activeZones: {}, // Track which zones are displayed: { "1-R-3": true }
            loadingZones: {}, // Track which zones are loading: { "1-R-3": true }
            layers: [
                {
                    id: 'towb',
                    label: 'All',
                    enabled: true,
                    groupName: 'towb',
                    color: '#FFFF00',
                    municipalityId: 3 // Wrightsville Beach
                },
                {
                    id: 'tocb',
                    label: 'All',
                    enabled: true,
                    groupName: 'tocb',
                    color: 'rgb(140, 26, 255)',
                    municipalityId: 2 // Carolina Beach
                },
                {
                    id: 'nhc',
                    label: 'All',
                    enabled: true,
                    groupName: 'nhc',
                    color: 'rgb(0, 150, 255)',
                    municipalityId: 5 // New Hanover County
                },
                {
                    id: 'wilmington',
                    label: 'All',
                    enabled: true,
                    groupName: 'wilmington',
                    color: 'rgb(0, 200, 100)',
                    municipalityId: 1 // Wilmington
                },
                {
                    id: 'wilmington-historic',
                    label: 'Historic Districts',
                    enabled: false,
                    groupName: 'wilmington-historic',
                    color: 'rgb(0, 120, 60)',
                    municipalityId: 1
                },
                {
                    id: 'wilmington-1945',
                    label: '1945 Limits',
                    enabled: false,
                    groupName: 'wilmington-1945',
                    color: 'rgb(0, 120, 60)',
                    municipalityId: 1
                },
                {
                    id: 'tocb-heightoverlay',
                    label: 'Height Overlay District (45ft)',
                    enabled: false,
                    groupName: 'tocb-heightoverlay',
                    color: 'rgb(0, 120, 60)',
                    municipalityId: 2 // Carolina Beach
                }
            ]
        }
    },
    methods: {
        openRegistration(mode = 'login', message = '', email = '', state = 'login') {
            this.showRegistrationOverlay = true;
            this.authMode = mode;
            this.authState = state;
            this.authMessage = message || '';
            this.authAlertVariant = state === 'success' ? 'success' : 'danger';
            this.authEmail = email || this.authEmail || '';
            // Set registration email if provided
            if (email) {
                this.registerEmail = email;
            }
            this.otpCode = '';
        },
        closeRegistration() {
            this.showRegistrationOverlay = false;
            this.authMessage = '';
            this.authMode = 'login';
            this.authState = 'login';
            this.authAlertVariant = 'danger';
            this.authEmail = '';
            this.otpCode = '';
            // Clear registration form data
            this.registerEmail = '';
            this.registerFirstName = '';
            this.registerLastName = '';
            this.registerProfession = '';
            this.showTermsOfUse = false;
            this.termsAccepted = false;
            this.authLoading = false;
        },
        // Global Modal methods
        openGlobalModal(content = '') {
            this.globalModalContent = content;
            this.showGlobalModal = true;
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        },
        closeGlobalModal() {
            this.showGlobalModal = false;
            this.globalModalContent = '';
            // Restore body scroll
            document.body.style.overflow = '';
        },
        closeBanner() {
            this.bannerHidden = true;
            // Wait for transition to complete before removing from DOM
            setTimeout(() => {
                this.showBanner = false;
            }, 300); // Match CSS transition duration
        },
        openContactModal() {
            const contactContent = 'To get in touch with the creator send an email to <a href="mailto:tim@byright.ai">tim@byright.ai</a>';
            this.openGlobalModal(contactContent);
        },
        handleSessionExpired() {
            // Update auth state
            this.isAuthenticated = false;
            // Show login overlay with session expired message
            this.openRegistration('login', 'Your session has expired. Please log in again.', '', 'login');
            // Clean up URL
            const params = new URLSearchParams(window.location.search);
            params.delete('sessionExpired');
            const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
            window.history.replaceState({}, '', newUrl);
        },
        async checkAuthStatus(retryCount = 0) {
            try {
                const response = await ApiClient.get('/auth/check');
                if (response.ok) {
                    const data = await response.json();
                    this.isAuthenticated = data.isAuthenticated === true;
                } else {
                    this.isAuthenticated = false;
                }
            } catch (err) {
                console.debug('Error checking auth status:', err);
                // Retry once after a short delay if this is the first attempt
                // (helps with timing issues after login redirect)
                if (retryCount === 0) {
                    await new Promise(resolve => setTimeout(resolve, 200));
                    return this.checkAuthStatus(1);
                }
                this.isAuthenticated = false;
            }
        },
        async handleLogout() {
            // Submit the logout form
            const form = event.target;
            const formData = new FormData(form);
            const response = await ApiClient.fetch('/auth/logout', {
                method: 'POST',
                body: formData
            });
            // Update auth status after logout
            this.isAuthenticated = false;
            // Redirect to home
            window.location.href = '/';
        },
        switchToRegister() {
            this.authMode = 'register';
            this.authState = 'register';
            this.authMessage = '';
            this.authAlertVariant = 'danger';
            this.otpCode = '';
            this.showTermsOfUse = false;
            this.termsAccepted = false;
        },
        switchToLogin() {
            this.authMode = 'login';
            this.authState = 'login';
            this.authMessage = '';
            this.authAlertVariant = 'danger';
            this.otpCode = '';
            this.showTermsOfUse = false;
            this.termsAccepted = false;
        },
        async handleLogin() {
            // Get email from Vue data (v-model should keep it in sync)
            const email = this.authEmail?.trim();

            if (!email) {
                this.openRegistration('login', 'Email is required', '', 'login');
                return;
            }

            this.authLoading = true;
            try {
                const response = await ApiClient.post('/auth/login-otp', { email: email }, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        // Show success message and switch to OTP verification
                        this.openRegistration(
                            'login',
                            data.message,
                            data.email,
                            'success'
                        );
                    }
                } else {
                    const errorData = await response.json().catch(() => ({ error: 'An error occurred' }));
                    // Show error message
                    if (errorData.showRegistration) {
                        // User not found, show registration
                        this.openRegistration(
                            'register',
                            errorData.error,
                            errorData.email,
                            'register'
                        );
                    } else {
                        // Show error in login form
                        this.openRegistration(
                            'login',
                            errorData.error,
                            errorData.email || email,
                            'login'
                        );
                    }
                }
            } catch (err) {
                console.error('Login error:', err);
                this.openRegistration(
                    'login',
                    'An error occurred while signing in. Please try again.',
                    email,
                    'login'
                );
            } finally {
                this.authLoading = false;
            }
        },
        async handleVerifyCode() {
            // Get email and code from Vue data (v-model should keep them in sync)
            const email = this.authEmail?.trim();
            const code = this.otpCode?.trim();

            if (!email || !code) {
                this.openRegistration('login', 'Email and verification code are required', email || '', 'success');
                return;
            }

            this.authLoading = true;
            try {
                const response = await ApiClient.post('/auth/verify-code',
                    { Email: email, Code: code },
                    {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json'
                        }
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    // Update auth status after successful login
                    await this.checkAuthStatus();
                    // Close registration overlay
                    this.closeRegistration();

                    // Update URL without page refresh
                    const params = new URLSearchParams(window.location.search);
                    params.delete('loginSuccess'); // Clean up if it exists
                    params.delete('openRegistration');
                    params.delete('openLoginError');
                    params.delete('sessionExpired');
                    const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
                    window.history.replaceState({}, '', newUrl);

                    // If user is on a tab that requires authentication, reload the data
                    if (this.isAuthenticated && this.showInspectionPanel) {
                        const authRequiredTabs = ['uses', 'setbacks', 'floodzone'];
                        if (authRequiredTabs.includes(this.inspectionActiveTab)) {
                            // Reload data for the current tab
                            if (this.inspectionActiveTab === 'uses') {
                                await this.loadPermittedUses();
                            } else if (this.inspectionActiveTab === 'setbacks') {
                                await this.loadSetbacks();
                            } else if (this.inspectionActiveTab === 'floodzone') {
                                await this.loadFloodZonesForTab();
                            }
                        }
                    }
                } else {
                    // Handle error response
                    try {
                        const errorData = await response.json();
                        this.openRegistration(
                            'login',
                            errorData.error || 'Verification failed. Please try again.',
                            errorData.email || email,
                            'success'
                        );
                    } catch (err) {
                        // On error, show generic error message
                        this.openRegistration(
                            'login',
                            'Verification failed. Please try again.',
                            email,
                            'success'
                        );
                    }
                }
            } catch (err) {
                console.error('Verify code error:', err);
                this.openRegistration(
                    'login',
                    'An error occurred during verification. Please try again.',
                    email,
                    'success'
                );
            } finally {
                this.authLoading = false;
            }
        },
        async handleRegister() {
            // Get form data from Vue data (v-model should keep them in sync)
            const email = this.registerEmail?.trim();
            const firstName = this.registerFirstName?.trim();
            const lastName = this.registerLastName?.trim();
            const profession = this.registerProfession?.trim();
            const termsAccepted = this.termsAccepted;

            if (!email || !firstName || !lastName || !profession) {
                this.openRegistration('register', 'All fields are required', email || '', 'register');
                return;
            }

            if (!termsAccepted) {
                this.openRegistration('register', 'You must agree to the terms of use to continue', email || '', 'register');
                return;
            }

            this.authLoading = true;
            try {
                const response = await ApiClient.post('/registration/register', {
                    Email: email,
                    FirstName: firstName,
                    LastName: lastName,
                    Profession: profession,
                    TermsAccepted: termsAccepted
                }, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        // Show success message and switch to OTP verification
                        this.openRegistration(
                            'login',
                            data.message,
                            data.email,
                            'success'
                        );
                        // Clear registration form data
                        this.registerEmail = '';
                        this.registerFirstName = '';
                        this.registerLastName = '';
                        this.registerProfession = '';
                    }
                } else {
                    const errorData = await response.json().catch(() => ({ error: 'An error occurred' }));
                    this.openRegistration(
                        'register',
                        errorData.error || 'Registration failed. Please try again.',
                        errorData.email || email,
                        'register'
                    );
                }
            } catch (err) {
                console.error('Registration error:', err);
                this.openRegistration(
                    'register',
                    'An error occurred while registering. Please try again.',
                    email,
                    'register'
                );
            } finally {
                this.authLoading = false;
            }
        },
        toggleMeasuringTools() {
            this.isMeasuringCollapsed = !this.isMeasuringCollapsed;
        },
        toggleFloodMap() {
            this.isFloodMapCollapsed = !this.isFloodMapCollapsed;
        },
        toggleMunicipalityZoning(municipalityId) {
            const municipality = this.municipalities.find(m => m.id === municipalityId);
            if (municipality) {
                municipality.zoningCollapsed = !municipality.zoningCollapsed;
            }
        },
        toggleMunicipalityUses(municipalityId) {
            const municipality = this.municipalities.find(m => m.id === municipalityId);
            if (municipality) {
                municipality.usesCollapsed = !municipality.usesCollapsed;
            }
        },
        toggleLayer(layer) {
            // Use the MapLayers module to toggle layers
            if (MapLayers && MapLayers.toggleLayerGroup) {
                MapLayers.toggleLayerGroup(layer.groupName, layer.enabled);
            }
        },
        disableAllZoningLayers() {
            // Disable all 4 zoning layers
            const zoningLayerGroupNames = ['towb', 'tocb', 'nhc', 'wilmington'];
            zoningLayerGroupNames.forEach(groupName => {
                const layer = this.layers.find(l => l.groupName === groupName);
                if (layer) {
                    layer.enabled = false;
                    if (MapLayers && MapLayers.toggleLayerGroup) {
                        MapLayers.toggleLayerGroup(groupName, false);
                    }
                }
            });
        },
        disableHistoricLayers() {
            const layer = this.layers.find(l => l.groupName === 'wilmington-historic');
            if (layer) {
                layer.enabled = false;
                if (MapLayers && MapLayers.toggleLayerGroup) {
                    MapLayers.toggleLayerGroup('wilmington-historic', false);
                }
            }
        },
        disableHistoric1945Layer() {
            const layer = this.layers.find(l => l.groupName === 'wilmington-1945');
            if (layer) {
                layer.enabled = false;
                if (MapLayers && MapLayers.toggleLayerGroup) {
                    MapLayers.toggleLayerGroup('wilmington-1945', false);
                }
            }
        },
        disableHeightOverlayLayer() {
            const layer = this.layers.find(l => l.groupName === 'tocb-heightoverlay');
            if (layer) {
                layer.enabled = false;
                if (MapLayers && MapLayers.toggleLayerGroup) {
                    MapLayers.toggleLayerGroup('tocb-heightoverlay', false);
                }
            }
        },
        toggleFloodLayer() {
            // Toggle the flood layer using MapLayers
            if (MapLayers && MapLayers.toggleLayerGroup) {
                MapLayers.toggleLayerGroup('NHC_FloodLayer', this.floodLayerEnabled);
            }
        },
        toggleWetlandsLayer() {
            // Toggle the wetlands layer using MapLayers
            if (MapLayers && MapLayers.toggleLayerGroup) {
                MapLayers.toggleLayerGroup('NHC_WetLands', this.wetlandsLayerEnabled);
            }
        },
        disableFloodLayer() {
            // Disable the flood layer
            this.floodLayerEnabled = false;
            if (MapLayers && MapLayers.toggleLayerGroup) {
                MapLayers.toggleLayerGroup('NHC_FloodLayer', false);
            }
        },
        disableWetlandsLayer() {
            // Disable the wetlands layer
            this.wetlandsLayerEnabled = false;
            if (MapLayers && MapLayers.toggleLayerGroup) {
                MapLayers.toggleLayerGroup('NHC_WetLands', false);
            }
        },
        centerOnUserLocation() {
            if (!window.map) {
                console.error('Map not available');
                return;
            }

            if (!navigator.geolocation) {
                this.openGlobalModal('Geolocation is not supported by your browser.');
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    const userPos = [longitude, latitude];

                    // Center map on user location with a reasonable zoom level
                    window.map.setCamera({
                        center: userPos,
                        zoom: 16
                    });
                },
                (error) => {
                    console.error('Geolocation error:', error);
                    let errorMessage = 'Unable to get your location. ';
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage += 'Please allow location access in your browser settings.';
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage += 'Location information is unavailable.';
                            break;
                        case error.TIMEOUT:
                            errorMessage += 'Location request timed out.';
                            break;
                        default:
                            errorMessage += 'An unknown error occurred.';
                            break;
                    }
                    this.openGlobalModal(errorMessage);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 60000
                }
            );
        },
        toggleSatelliteImagery() {
            if (!window.map) {
                console.error('Map not available');
                return;
            }
            
            // Helper function to disable all custom layers
            const disableAllCustomLayers = () => {
                
                // Disable base map layers by ID
                const baseMapLayerIds = [
                    'basemap_nhc-zoning-labels',
                    'basemap_nhc_water-zoning-fill',
                    'basemap_nhc_building-zoning-fill',
                    'basemap_nhc_muni-zoning-fill',
                    'basemap_nhc_road-primary-casing',
                    'basemap_nhc_road-primary-fill',
                    'basemap_nhc_road-res-casing',
                    'basemap_nhc_road-res-fill'
                ];
                
                baseMapLayerIds.forEach(layerId => {
                    try {
                        const layer = window.map.layers.getLayerById(layerId);
                        if (layer) {
                            layer.setOptions({ visible: false });
                        }
                    } catch (e) {
                        // Layer might not exist, ignore
                    }
                });
            };
            
            // Helper function to reinitialize all layers
            const reinitializeLayers = () => {
                const baseMapLayerIds = [
                    'basemap_nhc-zoning-labels',
                    'basemap_nhc_water-zoning-fill',
                    'basemap_nhc_building-zoning-fill',
                    'basemap_nhc_muni-zoning-fill',
                    'basemap_nhc_road-primary-casing',
                    'basemap_nhc_road-primary-fill',
                    'basemap_nhc_road-res-casing',
                    'basemap_nhc_road-res-fill'
                ];

                baseMapLayerIds.forEach(layerId => {
                    try {
                        const layer = window.map.layers.getLayerById(layerId);
                        if (layer) {
                            layer.setOptions({ visible: true });
                        }
                    } catch (e) {
                        // Layer might not exist, ignore
                    }
                });
            };
            
            try {
                if (this.isSatelliteMode) {
                    // Switch back to blank style
                    console.log('Switching to blank style');
                    this.isSatelliteMode = false;
                    window.map.setStyle({ style: 'blank' });
                    
                    // Hide banner when switching back to blank
                    this.closeBanner();
                    
                    // Unlock map interactions
                    window.map.setUserInteraction({
                        dragPanInteraction: true,
                        scrollZoomInteraction: true,
                        dblClickZoomInteraction: true,
                        boxZoomInteraction: true,
                        keyboardInteraction: true,
                        dragRotateInteraction: true,
                        touchInteraction: true
                    });
                    
                    // Re-initialize layers when style is loaded
                    window.map.events.addOnce('ready', function() {
                        reinitializeLayers();
                    });
                } else {

                    // Disable all custom layers before switching
                    disableAllCustomLayers();
                    
                    this.isSatelliteMode = true;
                    window.map.setStyle({ style: 'satellite_road_labels' });
                    
                    // Lock map interactions (disable zoom/pan)
                    window.map.setUserInteraction({
                        dragPanInteraction: false,
                        scrollZoomInteraction: false,
                        dblClickZoomInteraction: false,
                        boxZoomInteraction: false,
                        keyboardInteraction: false,
                        dragRotateInteraction: false,
                        touchInteraction: false
                    });
                    
                    // Show banner with message about zoom/pan being disabled
                    this.bannerContent = 'The map cannot be zoomed or panned when viewing satellite imagery.';
                    this.bannerHidden = false;
                    this.showBanner = true;
                    
                    // Auto-fade banner after 30 seconds
                    //setTimeout(() => {
                    //    if (this.showBanner) {
                    //        this.closeBanner();
                    //    }
                    //}, 10000);
                }
            } catch (error) {
                console.error('Error toggling satellite imagery:', error);
                console.error('Map object:', window.map);
                console.error('setStyle method:', typeof window.map.setStyle);
                // Revert state on error
                this.isSatelliteMode = !this.isSatelliteMode;
            }
        },
        async handleCategoryChange(category, municipalityId) {
            this.selectedUseCategory = category || '';
            if (!category) {
                return;
            }

            this.usesLoading = true;
            try {
                if (typeof MapLayers !== 'undefined' && MapLayers.searchPermittedUsesByCategory) {
                    const results = await MapLayers.searchPermittedUsesByCategory(category, municipalityId || 1);

                    // Automatically check all results
                    const newChecked = {};
                    results.forEach(use => {
                        if (use && use.id) {
                            newChecked[use.id] = use;
                        }
                    });

                    // Merge with existing checked items
                    this.usesChecked = { ...this.usesChecked, ...newChecked };

                    // Update results list with checked items on top
                    const checkedArr = Object.values(this.usesChecked);
                    const others = results.filter(r => !this.usesChecked[r.id]);
                    this.usesResults = [...checkedArr, ...others];
                }
            } catch (err) {
                console.debug('Category search error:', err);
            } finally {
                this.usesLoading = false;
            }
        },
        handleUsesInput(value, municipalityId) {
            this.usesSearchTerm = value || '';
            if (this.usesSearchTimer) {
                clearTimeout(this.usesSearchTimer);
            }
            // Debounce 500ms
            this.usesSearchTimer = setTimeout(() => {
                this.fetchPermittedUses(municipalityId);
            }, 500);
        },
        async fetchPermittedUses(municipalityId) {
            const query = (this.usesSearchTerm || '').trim();
            if (!query) {
                // If no query, show only checked items
                this.usesResults = Object.values(this.usesChecked);
                return;
            }
            this.usesLoading = true;
            try {
                if (typeof MapLayers !== 'undefined' && MapLayers.searchPermittedUses) {
                    const results = await MapLayers.searchPermittedUses(query, municipalityId || 1);
                    const checked = Object.values(this.usesChecked);
                    const newResults = (results || []).filter(r => !this.usesChecked[r.id]);
                    this.usesResults = [...checked, ...newResults];
                } else {
                    this.usesResults = [];
                }
            } catch (err) {
                console.debug('Permitted uses search error:', err);
                this.usesResults = [];
            } finally {
                this.usesLoading = false;
            }
        },
        toggleUseChecked(use, checked) {
            if (!use || !use.id) return;
            if (checked) {
                this.usesChecked = { ...this.usesChecked, [use.id]: use };
            } else {
                // Create new object without the unchecked item to ensure Vue reactivity
                const { [use.id]: removed, ...updated } = this.usesChecked;
                this.usesChecked = updated;

                // If all filters are now unchecked, remove the layer
                if (Object.keys(updated).length === 0) {
                    if (window.mapInstance && MapLayers.removeFilteredParcels) {
                        MapLayers.removeFilteredParcels(window.mapInstance);
                    }
                    // Clear active filtered uses
                    this.activeFilteredUses = [];
                }
            }
            // Rebuild list with checked items on top
            const checkedArr = Object.values(this.usesChecked);
            const others = (this.usesResults || []).filter(u => !this.usesChecked[u.id]);
            this.usesResults = [...checkedArr, ...others];
        },
        clearUseFilters() {
            // Uncheck all active filtered uses
            if (this.activeFilteredUses && this.activeFilteredUses.length > 0) {
                this.activeFilteredUses.forEach(use => {
                    if (this.usesChecked[use.id]) {
                        this.toggleUseChecked(use, false);
                    }
                });
            }

            // Remove the filtered parcels layer
            if (window.mapInstance && MapLayers.removeFilteredParcels) {
                MapLayers.removeFilteredParcels(window.mapInstance);
            }

            // Clear active filtered uses
            this.activeFilteredUses = [];
        },
        async applyUseFilter(municipalityId) {
            const selectedNames = Object.values(this.usesChecked)
                .map(u => u.name)
                .filter(Boolean);

            // Always remove existing filtered parcels first
            if (window.mapInstance && MapLayers.removeFilteredParcels) {
                MapLayers.removeFilteredParcels(window.mapInstance);
            }

            // Clear active filtered uses
            this.activeFilteredUses = [];

            if (selectedNames.length === 0) {
                // No uses selected, just clear and return
                return;
            }

            // Show loading overlay
            if (window.MapLoading) {
                MapLoading.show();
            }

            try {
                const requestBody = {
                    selectedNames: selectedNames,
                    statusFilters: this.useStatusFilters
                };

                const response = await ApiClient.post(`/api/uses/filter?municipalityId=${municipalityId}`, requestBody);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const filterResults = await response.json();

                // Load new filtered parcels on the map
                if (window.mapInstance && MapLayers.loadFilteredParcels) {
                    MapLayers.loadFilteredParcels(window.mapInstance, filterResults);

                    // Update active filtered uses to show what's currently displayed
                    this.activeFilteredUses = Object.values(this.usesChecked).filter(u =>
                        selectedNames.includes(u.name)
                    );

                    // Toggle off the municipality layer if it's enabled
                    const municipalityLayer = this.getLayerForMunicipality(municipalityId);
                    if (municipalityLayer && municipalityLayer.enabled) {
                        municipalityLayer.enabled = false;
                        this.toggleLayer(municipalityLayer);
                    }
                }
            } catch (err) {
                console.error('Uses filter error:', err);
                alert('Error applying use filter. Please try again.');
            } finally {
                // Hide loading overlay
                if (window.MapLoading) {
                    MapLoading.hide();
                }
            }
        },
        async handleSearch() {
            // Close inspection panel when search is executed
            if (this.showInspectionPanel) {
                this.closeInspectionPanel();
            }

            // Clear suggested addresses dropdown when search button is clicked
            this.searchResults = [];

            // Clear any pending debounce timer
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
                this.searchDebounceTimer = null;
            }

            if (!this.searchAddress || !this.searchAddress.trim()) {
                return;
            }

            const searchInput = this.searchAddress.trim();

            // Check if input matches Parcel ID pattern (starts with R, then 1-10 digits, hyphen, 1-10 digits, hyphen, 1-10 digits, hyphen, 1-10 digits)
            const parcelIdPattern = /^R\d{1,10}-\d{1,10}-\d{1,10}-\d{1,10}$/;

            if (parcelIdPattern.test(searchInput)) {
                // It's a Parcel ID search
                await this.searchByParcelId(searchInput);
            } else {
                // Regular address search
                if (typeof searchParcel === 'function') {
                    try {
                        await searchParcel(searchInput);
                    } catch (error) {
                        console.error('Geocode error:', error);
                        // Show error message in global modal
                        this.openGlobalModal('Sorry, that address could not be found. Make sure you include City or zipcode if only supplying address');
                    }
                }
            }
        },
        async searchByParcelId(parcelId) {
            try {
                // Clear any existing search results
                this.searchResults = [];

                const response = await ApiClient.get(`/api/Parcel/location?pid=${encodeURIComponent(parcelId)}`);

                if (!response.ok) {
                    if (response.status === 404) {
                        alert(`Parcel ID '${parcelId}' not found`);
                    } else {
                        alert('Error searching for parcel');
                    }
                    return;
                }

                const data = await response.json();

                // Zoom to the location and add a marker
                if (window.mapInstance && MapMarkers) {
                    const position = [data.longitude, data.latitude];
                    const address = data.parcelAddress || parcelId;
                    MapMarkers.selectAddress(window.mapInstance, position, address);
                }
            } catch (error) {
                console.error('Error searching by Parcel ID:', error);
                alert('Error searching for parcel');
            }
        },
        clearDrawings() {
            if (MapDrawing && MapDrawing.clearAll) {
                MapDrawing.clearAll();
            }
            this.isPolygonDrawing = false;
            this.isLineDrawing = false;
            this.showLineDrawingAlert = false;
            this.showPolygonDrawingAlert = false;
        },
        startMeasureDistance() {
            if (MapDrawing && MapDrawing.startDrawingLine) {
                MapDrawing.startDrawingLine();
            }
            this.isPolygonDrawing = false;
            this.isLineDrawing = true;
            this.showPolygonDrawingAlert = false;
            // Show line drawing alert with appropriate message for mobile vs non-mobile
            if (this.isMobile) {
                this.lineDrawingAlertMessage = 'Tap once to start, then tap again to set the end point.';
            } else {
                this.lineDrawingAlertMessage = 'Click once to start, then double-click to set the end point.';
            }
            this.showLineDrawingAlert = true;
            // Collapse zoning tree on mobile
            if (this.isMobile) {
                this.isZoningTreeCollapsed = true;
            }
        },
        startMeasureArea() {
            if (MapDrawing && MapDrawing.startDrawingPolygon) {
                MapDrawing.startDrawingPolygon();
                this.isPolygonDrawing = true;
            }
            this.isLineDrawing = false;
            this.showLineDrawingAlert = false;
            // Show polygon drawing alert with appropriate message for mobile vs non-mobile
            if (this.isMobile) {
                this.polygonDrawingAlertMessage = 'Tap the map to add points. Tap Finish when finished.';
            } else {
                this.polygonDrawingAlertMessage = 'Click the map to add points. Double click when finished.';
            }
            this.showPolygonDrawingAlert = true;
            // Collapse zoning tree on mobile
            if (this.isMobile) {
                this.isZoningTreeCollapsed = true;
            }
        },
        finishDrawing() {
            if (MapDrawing && MapDrawing.finishDrawing) {
                MapDrawing.finishDrawing();
            }
            this.isPolygonDrawing = false;
            this.isLineDrawing = false;
            this.showPolygonDrawingAlert = false;
            // Hide alert on non-mobile (mobile can edit, so keep alert visible)
            if (!this.isMobile) {
                this.showLineDrawingAlert = false;
            }
            // Reset messages based on device type
            this.lineDrawingAlertMessage = this.isMobile
                ? 'Tap once to start, then tap again to set the end point.'
                : 'Click once to start, then double-click to set the end point.';
            this.polygonDrawingAlertMessage = this.isMobile
                ? 'Tap the map to add points. Tap Finish when finished.'
                : 'Click the map to add points. Double click when finished.';
        },
        selectAddress(result) {
            // Close inspection panel when an address is selected from suggestions
            if (this.showInspectionPanel) {
                this.closeInspectionPanel();
            }

            if (result.position && MapMarkers && MapMarkers.selectAddress) {
                // Set flag to prevent watcher from triggering search
                this.isSelectingAddress = true;

                // Clear results immediately before doing anything else
                this.searchResults = [];

                // Use the formatted address for the search
                this.searchAddress = result.address;

                // Call the MapMarkers function to handle zoom and marker
                const map = window.mapInstance || window.map;
                MapMarkers.selectAddress(map, result.position, result.address);

                // Reset flag after a brief delay to allow the address to be set
                setTimeout(() => {
                    this.isSelectingAddress = false;
                }, 100);
            }
        },
        positionSearchResults() {
            // Position search results dropdown on mobile
            if (this.searchResults && this.searchResults.length > 0) {
                this.$nextTick(() => {
                    const searchContainer = document.querySelector('#address-search .search-container');
                    const searchResults = document.querySelector('.search-results');
                    if (searchContainer && searchResults && window.innerWidth <= 576) {
                        const containerRect = searchContainer.getBoundingClientRect();
                        searchResults.style.top = `${containerRect.bottom + 4}px`;
                    }
                });
            }
        },
        scrollTabsToRight() {
            if (this.$refs.inspectionTabs) {
                const tabsElement = this.$refs.inspectionTabs;
                tabsElement.scrollTo({
                    left: tabsElement.scrollWidth,
                    behavior: 'smooth'
                });
            }
        },
        checkTabsScroll() {
            // Check if inspection tabs can scroll horizontally and if scrolled to end
            this.$nextTick(() => {
                const tabsElement = this.$refs.inspectionTabs;
                if (tabsElement && window.innerWidth <= 576) {
                    const canScroll = tabsElement.scrollWidth > tabsElement.clientWidth;
                    this.tabsCanScroll = canScroll;
                    
                    if (canScroll) {
                        // Check if scrolled to the right
                        const scrollLeft = tabsElement.scrollLeft;
                        const scrollWidth = tabsElement.scrollWidth;
                        const clientWidth = tabsElement.clientWidth;
                        const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1; // -1 for rounding
                        this.tabsScrolledToEnd = isAtEnd;
                        
                        // Set up scroll listener if not already set up
                        if (!tabsElement.hasAttribute('data-scroll-listener')) {
                            this.setupTabsScrollListener();
                            tabsElement.setAttribute('data-scroll-listener', 'true');
                        }
                    } else {
                        this.tabsScrolledToEnd = false;
                    }
                } else {
                    this.tabsCanScroll = false;
                    this.tabsScrolledToEnd = false;
                }
            });
        },
        setupTabsScrollListener() {
            // Listen to scroll events on tabs to update scroll state
            this.$nextTick(() => {
                const tabsElement = this.$refs.inspectionTabs;
                if (tabsElement) {
                    // Remove existing listener if any
                    const scrollHandler = () => {
                        this.checkTabsScroll();
                    };
                    tabsElement.removeEventListener('scroll', scrollHandler);
                    tabsElement.addEventListener('scroll', scrollHandler);
                }
            });
        },
        showInspectionData(details, address, parcels = []) {
            // If 3D terrain viewer is open, close it when a new address/parcel is selected
            if (this.showTerrain3D) {
                this.closeTerrain3D();
            }
            // Always reset to PARCEL INFO tab when a new parcel is selected
            this.inspectionActiveTab = 'parcel';

            this.parcelDetails = details || {
                acres: null,
                pid: null,
                zoningDistrict: null,
                municipalityId: details && details.municipalityId ? details.municipalityId : null,
                totalFrontageFeet: null,
                areaSquareFeet: null,
                latitude: null,
                longitude: null,
                isWithinHistoricDistrict: false,
                isWithinHistoric1945: false,
                isWithinHeightOverlay: false
            };
            this.inspectionAddress = address || null;
            this.parcelRecords = Array.isArray(parcels) ? parcels : [];
            this.selectedParcelIndex = 0;

            // If we have parcel records, prefer the first one for summary values
            const current = this.currentParcel;
            if (current) {
                this.parcelDetails = {
                    acres: current.acres || this.parcelDetails.acres,
                    pid: current.parcelId || current.pid || this.parcelDetails.pid,
                    zoningDistrict: current.zoning || current.zoningDistrict || this.parcelDetails.zoningDistrict,
                    // IMPORTANT: prefer municipality inferred from zoning layer (details.municipalityId)
                    // and only fall back to the parcel's MunicipalityID if zoning didn't provide one.
                    municipalityId: this.parcelDetails.municipalityId || current.municipalityID || null,
                    totalFrontageFeet: this.parcelDetails.totalFrontageFeet || null,
                    areaSquareFeet: this.parcelDetails.areaSquareFeet || null,
                    latitude: this.parcelDetails.latitude || null,
                    longitude: this.parcelDetails.longitude || null,
                    isWithinHistoricDistrict: this.parcelDetails.isWithinHistoricDistrict || false,
                    isWithinHistoric1945: this.parcelDetails.isWithinHistoric1945 || false,
                    isWithinHeightOverlay: this.parcelDetails.isWithinHeightOverlay || false
                };
            }

            // On mobile, show button instead of panel. On desktop, show panel directly.
            if (this.isMobile) {
                // Store the data for when button is clicked
                this.pendingParcelData = { ...this.parcelDetails };
                this.pendingParcelAddress = address;
                this.pendingParcelRecords = Array.isArray(parcels) ? parcels : [];
                this.showParcelDetailsButton = true;
            } else {
                this.showInspectionPanel = true;
                this.setupTabsScrollListener();
            }

            // Reset flood zone, wetland, and soil data when a new parcel is selected
            this.floodZoneData = null;
            this.wetlandData = null;
            this.soilData = null;
        },
        openInspectionPanelFromButton() {
            // Restore the parcel data and show the panel
            if (this.pendingParcelData) {
                this.parcelDetails = { ...this.pendingParcelData };
                this.inspectionAddress = this.pendingParcelAddress;
                this.parcelRecords = [...this.pendingParcelRecords];
                this.selectedParcelIndex = 0;

                // If we have parcel records, prefer the first one for summary values
                const current = this.currentParcel;
                if (current) {
                    this.parcelDetails = {
                        acres: current.acres || this.parcelDetails.acres,
                        pid: current.parcelId || current.pid || this.parcelDetails.pid,
                        zoningDistrict: current.zoning || current.zoningDistrict || this.parcelDetails.zoningDistrict,
                        municipalityId: this.parcelDetails.municipalityId || current.municipalityID || null,
                        totalFrontageFeet: this.parcelDetails.totalFrontageFeet || null,
                        areaSquareFeet: this.parcelDetails.areaSquareFeet || null,
                        latitude: this.parcelDetails.latitude || null,
                        longitude: this.parcelDetails.longitude || null,
                        isWithinHistoricDistrict: this.parcelDetails.isWithinHistoricDistrict || false,
                        isWithinHistoric1945: this.parcelDetails.isWithinHistoric1945 || false,
                        isWithinHeightOverlay: this.parcelDetails.isWithinHeightOverlay || false
                    };
                }
            }

            this.showParcelDetailsButton = false;
            this.showInspectionPanel = true;
            this.pendingParcelData = null;
            this.pendingParcelAddress = null;
            this.pendingParcelRecords = [];
            this.setupTabsScrollListener();
        },
        async loadFloodZones(pid) {
            if (!pid) {
                this.floodZoneData = null;
                return;
            }

            try {
                const response = await ApiClient.get(`/api/Flood/by-parcel?pid=${encodeURIComponent(pid)}`);
                if (response.ok) {
                    const data = await response.json();
                    this.floodZoneData = data;
                } else {
                    this.floodZoneData = {};
                }
            } catch (err) {
                console.error('Error loading flood zones:', err);
                this.floodZoneData = null;
            }
        },
        async loadFloodZonesForTab() {
            // Don't make API call if not authenticated
            if (!this.isAuthenticated) {
                this.floodZoneData = null;
                this.wetlandData = null;
                this.soilData = null;
                return;
            }

            // Get the PID from the current parcel or parcel details
            const pid = (this.currentParcel && (this.currentParcel.parcelId || this.currentParcel.pid)) ||
                (this.parcelDetails && this.parcelDetails.pid);

            if (!pid) {
                this.floodZoneData = null;
                this.wetlandData = null;
                this.soilData = null;
                return;
            }

            // Only load if we don't already have data
            if (this.floodZoneData === null) {
                await this.loadFloodZones(pid);
            }
            if (this.wetlandData === null) {
                await this.loadWetlands(pid);
            }
            if (this.soilData === null) {
                await this.loadSoils(pid);
            }
        },
        async loadWetlands(pid) {
            if (!pid) {
                this.wetlandData = null;
                return;
            }

            try {
                const response = await ApiClient.get(`/api/Wetland/by-parcel?pid=${encodeURIComponent(pid)}`);
                if (response.ok) {
                    const data = await response.json();
                    this.wetlandData = data;
                    // Reset expanded state when loading new data
                    this.wetlandDetailsExpanded = {};
                } else {
                    this.wetlandData = {};
                }
            } catch (err) {
                console.error('Error loading wetlands:', err);
                this.wetlandData = null;
            }
        },
        async loadSoils(pid) {
            if (!pid) {
                this.soilData = null;
                return;
            }

            try {
                const response = await ApiClient.get(`/api/Soil/by-parcel?pid=${encodeURIComponent(pid)}`);
                if (response.ok) {
                    const data = await response.json();
                    this.soilData = data;
                } else {
                    this.soilData = {};
                }
            } catch (err) {
                console.error('Error loading soils:', err);
                this.soilData = null;
            }
        },
        toggleWetlandDetails(index) {
            // Vue 3: Direct assignment works with reactive objects
            this.wetlandDetailsExpanded[index] = !this.wetlandDetailsExpanded[index];
        },
        closeInspectionPanel() {
            this.showInspectionPanel = false;
            this.showParcelDetailsButton = false;
            this.pendingParcelData = null;
            this.pendingParcelAddress = null;
            this.pendingParcelRecords = [];
            this.parcelSideInfo = null;
            this.parcelBoundaryCoordinates = null;
            this.parcelDetails = {
                acres: null,
                pid: null,
                zoningDistrict: null,
                totalFrontageFeet: null,
                areaSquareFeet: null,
                latitude: null,
                longitude: null
            };
            this.floodZoneData = null;
            this.wetlandData = null;
            this.wetlandDetailsExpanded = {};
            this.soilData = null;
            this.inspectionAddress = null;
            this.parcelRecords = [];
            this.selectedParcelIndex = 0;
            this.inspectionActiveTab = 'parcel';
            this.permittedUses = {
                permittedByRight: [],
                permittedWithSupplemental: [],
                specialUsePermit: [],
                specialUsePermitSupplemental: [],
                conditionalZoning: [],
                conditionalZoningSupplemental: []
            };
            this.devStandards = {};
            // Close chat panel when closing inspection panel
            this.closeChatPanel();
            // Close parcel summary panel when closing inspection panel
            this.closeParcelSummaryPanel();
            // Don't clear side labels - keep them visible even after closing the panel
        },
        async openParcelSummary() {
            // Close chat panel if open
            if (this.showChatPanel) {
                this.closeChatPanel();
            }

            try {
                // Load flood zone data if not already loaded (needed for prompt attributes)
                if (this.floodZoneData === null) {
                    await this.loadFloodZonesForTab();
                }

                // Get parcel acres
                const acres = (this.currentParcel && this.currentParcel.acres) || this.parcelDetails?.acres;

                // Get parcel square footage - prefer calculated areaSquareFeet, fall back to calculation from acres
                let parcelSqft = null;
                if (this.parcelDetails?.areaSquareFeet !== null && this.parcelDetails?.areaSquareFeet !== undefined) {
                    parcelSqft = parseFloat(this.parcelDetails.areaSquareFeet);
                } else if (acres !== null && acres !== undefined) {
                    // Calculate parcel_sqft from acres (1 acre = 43,560 sqft) as fallback
                    parcelSqft = parseFloat(acres) * 43560;
                }

                // Build flood zone attributes
                let isFloodZone = false;
                let floodZoneClass = null;
                if (this.floodZoneData && this.floodZoneData.floodZones && this.floodZoneData.floodZones.length > 0) {
                    // Check if any flood zone is NOT "X" with "AREA OF MINIMAL FLOOD HAZARD"
                    const hasSignificantFloodZone = this.floodZoneData.floodZones.some(zone => {
                        const isMinimalHazard = zone.fldZone === 'X' &&
                            zone.zoneSubty === 'AREA OF MINIMAL FLOOD HAZARD';
                        return !isMinimalHazard;
                    });

                    isFloodZone = hasSignificantFloodZone;

                    // If true, build flood_zone_class by concatenating FLD_ZONE + ZONE_SUBTY + percentage
                    if (hasSignificantFloodZone && this.groupedFloodZones && this.groupedFloodZones.length > 0) {
                        const floodZoneClasses = this.groupedFloodZones
                            .filter(group => {
                                // Exclude "X" with "AREA OF MINIMAL FLOOD HAZARD"
                                return !(group.fldZone === 'X' && group.zoneSubty === 'AREA OF MINIMAL FLOOD HAZARD');
                            })
                            .map(group => {
                                // Concatenate FLD_ZONE + ZONE_SUBTY + percentage
                                const parts = [group.fldZone || ''];
                                if (group.zoneSubty) {
                                    parts.push(group.zoneSubty);
                                }
                                parts.push(`${group.coveragePercent.toFixed(2)}%`);
                                return parts.join(' ');
                            });

                        if (floodZoneClasses.length > 0) {
                            floodZoneClass = floodZoneClasses.join(', ');
                        }
                    }
                }

                const requestData = {
                    zoningDistrict: this.currentZoningDistrict || this.parcelDetails?.zoningDistrict || null,
                    address: this.inspectionAddress || null,
                    parcelId: (this.currentParcel && (this.currentParcel.parcelId || this.currentParcel.pid)) || this.parcelDetails?.pid || null,
                    municipalityId: this.currentMunicipalityId || 1,
                    is1945: this.parcelDetails?.isWithinHistoric1945 || false,
                    isHistoric: this.parcelDetails?.isWithinHistoricDistrict || false,
                    parcelAcres: acres !== null && acres !== undefined ? parseFloat(acres) : null,
                    parcelSqft: parcelSqft,
                    lotWidth: this.parcelDetails?.totalFrontageFeet !== null && this.parcelDetails?.totalFrontageFeet !== undefined ? parseFloat(this.parcelDetails.totalFrontageFeet) : null,
                    isFloodZone: isFloodZone,
                    floodZoneClass: floodZoneClass
                };

                this.parcelSummaryLoading = true;
                this.showParcelSummaryPanel = true;
                this.parcelSummaryData = null;

                const response = await ApiClient.post('/api/parcelsummary/parcel-summary', requestData, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    // Parse the JSON text from the summary property
                    try {
                        const summaryJson = JSON.parse(data.summary);
                        this.parcelSummaryData = summaryJson;
                    } catch (parseError) {
                        console.error('Error parsing parcel summary JSON:', parseError);
                        this.parcelSummaryData = { error: 'Failed to parse summary data' };
                    }
                } else {
                    const errorData = await response.json().catch(() => ({ error: 'An error occurred' }));
                    console.error('Error sending parcel summary:', errorData);
                    this.parcelSummaryData = { error: errorData.error || 'Failed to generate parcel summary' };
                }
            } catch (err) {
                console.error('Error opening parcel summary:', err);
                this.parcelSummaryData = { error: 'An error occurred while generating the parcel summary' };
            } finally {
                this.parcelSummaryLoading = false;
            }
        },
        closeParcelSummaryPanel() {
            this.showParcelSummaryPanel = false;
            this.parcelSummaryData = null;
        },
        formatParcelSummaryAsHtml(summaryData) {
            if (!summaryData || summaryData.error) {
                return `<div class="parcel-summary-error">${summaryData?.error || 'An error occurred'}</div>`;
            }

            let html = '<div class="parcel-summary">';

            // Add evaluation_basis if present
            if (summaryData.evaluation_basis) {
                html += `<div class="evaluation-basis"><p>${this.escapeHtml(summaryData.evaluation_basis)}</p></div>`;
            }

            // Process common_uses array
            if (summaryData.common_uses && Array.isArray(summaryData.common_uses)) {
                html += '<div class="common-uses"><h2>Common Uses</h2>';

                summaryData.common_uses.forEach(use => {
                    html += '<div class="use-item">';

                    // Use name
                    if (use.use_name) {
                        html += `<h3 class="use-name">${this.escapeHtml(use.use_name)}</h3>`;
                    }

                    // Status
                    if (use.status) {
                        const statusClass = use.status.replace(/_/g, '-');
                        html += `<div class="status status-${statusClass}"><strong>Status:</strong> ${this.escapeHtml(use.status)}</div>`;
                    }

                    // Reason
                    if (use.reason) {
                        html += `<div class="reason"><strong>Reason:</strong> ${this.escapeHtml(use.reason)}</div>`;
                    }

                    // Standards applied
                    if (use.standards_applied && Array.isArray(use.standards_applied)) {
                        html += '<div class="standards-applied"><h4>Standards Applied</h4>';
                        html += '<table class="standards-table"><thead><tr><th>Standard</th><th>Required</th><th>Parcel Value</th><th>Source References</th></tr></thead><tbody>';

                        use.standards_applied.forEach(standard => {
                            html += '<tr>';

                            // Standard name
                            html += `<td class="standard-name">${standard.standard ? this.escapeHtml(standard.standard) : ''}</td>`;

                            // Required value
                            let requiredValue = '';
                            if (standard.required !== null && standard.required !== undefined) {
                                if (typeof standard.required === 'string') {
                                    requiredValue = standard.required;
                                } else if (typeof standard.required === 'number') {
                                    requiredValue = standard.required.toString();
                                } else {
                                    requiredValue = 'None';
                                }
                            } else {
                                requiredValue = 'None';
                            }
                            html += `<td class="required-value">${this.escapeHtml(requiredValue)}</td>`;

                            // Parcel value
                            let parcelValueStr = '';
                            if (standard.parcel_value !== null && standard.parcel_value !== undefined) {
                                if (typeof standard.parcel_value === 'number') {
                                    parcelValueStr = standard.parcel_value.toString();
                                } else if (typeof standard.parcel_value === 'string') {
                                    parcelValueStr = standard.parcel_value;
                                }
                            }
                            html += `<td class="parcel-value">${this.escapeHtml(parcelValueStr)}</td>`;

                            // Source references
                            if (standard.source_refs && Array.isArray(standard.source_refs)) {
                                const refsList = standard.source_refs.map(ref => this.escapeHtml(ref)).join(', ');
                                html += `<td class="source-refs">${refsList}</td>`;
                            } else {
                                html += '<td></td>';
                            }

                            html += '</tr>';
                        });

                        html += '</tbody></table></div>';
                    }

                    html += '</div>';
                });

                html += '</div>';
            }

            html += '</div>';
            return html;
        },
        escapeHtml(text) {
            if (text === null || text === undefined) return '';
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        },
        async openChatPanel() {
            // Close parcel summary panel if open
            if (this.showParcelSummaryPanel) {
                this.closeParcelSummaryPanel();
            }

            // Pre-load setbacks if not already loaded
            if (this.currentZoningDistrict) {
                // COMMENTED OUT: Setbacks are now loaded in C# ChatController as promptSetbackAttributes
                // Check if setbacks are empty or not loaded
                // const hasSetbacks = this.setbacks &&
                //     (this.setbacks.front?.length > 0 ||
                //         this.setbacks.side?.length > 0 ||
                //         this.setbacks.rear?.length > 0 ||
                //         this.setbacks.corner?.length > 0);

                // if (!hasSetbacks) {
                //     await this.loadSetbacks();
                //     // Wait a bit for the setbacks to be set in vueApp
                //     await new Promise(resolve => setTimeout(resolve, 100));
                // }
            }

            // Fetch remaining chats count only when authenticated
            if (this.isAuthenticated) {
                await this.fetchRemainingChats();
            } else {
                this.remainingChats = null;
            }

            this.showChatPanel = true;
        },
        openTerrain3D() {
            const pid =
                (this.currentParcel && (this.currentParcel.parcelId || this.currentParcel.pid)) ||
                this.parcelDetails?.pid ||
                null;

            if (!pid) {
                console.error('No PID available for 3D view.');
                return;
            }

            this.showTerrain3D = true;

            this.$nextTick(() => {
                if (window.Terrain3D && typeof window.Terrain3D.showForPid === 'function') {
                    console.log('Opening 3D terrain with boundary coordinates:', this.parcelBoundaryCoordinates ? `${this.parcelBoundaryCoordinates.length} points` : 'none');
                    window.Terrain3D.showForPid(pid, this.parcelSideInfo, this.parcelBoundaryCoordinates);
                } else {
                    console.error('Terrain3D viewer is not initialized.');
                }
            });
        },
        closeTerrain3D() {
            this.showTerrain3D = false;
            // Clean up Three.js resources to prevent memory leaks
            if (window.Terrain3D && typeof window.Terrain3D.cleanup === 'function') {
                window.Terrain3D.cleanup();
            }
        },
        async fetchRemainingChats() {
            if (!this.isAuthenticated) {
                this.remainingChats = null;
                return;
            }
            try {
                const response = await ApiClient.get('/api/chat/remaining-chats');
                if (response.ok) {
                    const data = await response.json();
                    this.remainingChats = data.remaining || 0;
                } else {
                    // If unauthorized or error, set to null to hide the message
                    this.remainingChats = null;
                }
            } catch (error) {
                console.error('Error fetching remaining chats:', error);
                this.remainingChats = null;
            }
        },
        async buildPromptAttributes() {
            // COMMENTED OUT: Permitted uses, setbacks, and devstandards are now loaded in C# ChatController
            // Check if permitted uses need to be loaded
            // If we have a zoning district but all permitted use arrays are empty, load them
            // const hasPermittedUsesData = this.permittedUses && (
            //     (this.permittedUses.permittedByRight && this.permittedUses.permittedByRight.length > 0) ||
            //     (this.permittedUses.permittedWithSupplemental && this.permittedUses.permittedWithSupplemental.length > 0) ||
            //     (this.permittedUses.specialUsePermit && this.permittedUses.specialUsePermit.length > 0) ||
            //     (this.permittedUses.specialUsePermitSupplemental && this.permittedUses.specialUsePermitSupplemental.length > 0) ||
            //     (this.permittedUses.conditionalZoning && this.permittedUses.conditionalZoning.length > 0) ||
            //     (this.permittedUses.conditionalZoningSupplemental && this.permittedUses.conditionalZoningSupplemental.length > 0)
            // );

            // If we have a zoning district but no permitted uses data, and not currently loading, load them
            // if (this.currentZoningDistrict && !hasPermittedUsesData && !this.permittedUsesLoading && this.isAuthenticated) {
            //     await this.loadPermittedUses();
            // }

            const attributes = {};

            // Zoning district
            if (this.currentZoningDistrict) {
                attributes.zoning_district = this.currentZoningDistrict;
            }

            // Parcel acres
            const acres = (this.currentParcel && this.currentParcel.acres) || this.parcelDetails.acres;
            if (acres !== null && acres !== undefined) {
                attributes.parcel_acres = parseFloat(acres);
            }

            // Parcel square footage - prefer calculated areaSquareFeet, fall back to calculation from acres
            if (this.parcelDetails.areaSquareFeet !== null && this.parcelDetails.areaSquareFeet !== undefined) {
                attributes.parcel_sqft = parseFloat(this.parcelDetails.areaSquareFeet);
            } else if (acres !== null && acres !== undefined) {
                // Calculate parcel_sqft from acres (1 acre = 43,560 sqft) as fallback
                attributes.parcel_sqft = parseFloat(acres) * 43560;
            }

            // Lot width (total frontage)
            if (this.parcelDetails.totalFrontageFeet !== null && this.parcelDetails.totalFrontageFeet !== undefined) {
                attributes.lot_width = parseFloat(this.parcelDetails.totalFrontageFeet);
            }

            // Get base setbacks directly from this.setbacks
            // Find the base setback (is_base === true) for each type
            //const getBaseSetbackValue = (type) => {
            //    if (!this.setbacks || !this.setbacks[type]) {
            //        return null;
            //    }
            //    const setbacks = this.setbacks[type] || [];
            //    const baseSetback = setbacks.find(s => s.is_base === true);
            //    if (baseSetback && baseSetback.criteria !== null && baseSetback.criteria !== undefined) {
            //        const criteriaValue = parseFloat(baseSetback.criteria);
            //        if (!isNaN(criteriaValue)) {
            //            return criteriaValue;
            //        }
            //    }
            //    return null;
            //};

            //const frontSetbackValue = getBaseSetbackValue('front');
            //const rearSetbackValue = getBaseSetbackValue('rear');
            //const sideSetbackValue = getBaseSetbackValue('side');
            //const cornerSetbackValue = getBaseSetbackValue('corner');

            //if (frontSetbackValue !== null) {
            //    attributes.front_setback = frontSetbackValue;
            //}

            //if (rearSetbackValue !== null) {
            //    attributes.rear_setback = rearSetbackValue;
            //}

            //if (sideSetbackValue !== null) {
            //    attributes.side_setback = sideSetbackValue;
            //}

            //if (cornerSetbackValue !== null) {
            //    attributes.corner_setback = cornerSetbackValue;
            //}

            // Flood zone information
            if (this.floodZoneData && this.floodZoneData.floodZones && this.floodZoneData.floodZones.length > 0) {
                // Check if any flood zone is NOT "X" with "AREA OF MINIMAL FLOOD HAZARD"
                const hasSignificantFloodZone = this.floodZoneData.floodZones.some(zone => {
                    const isMinimalHazard = zone.fldZone === 'X' &&
                        zone.zoneSubty === 'AREA OF MINIMAL FLOOD HAZARD';
                    return !isMinimalHazard;
                });

                attributes.is_flood_zone = hasSignificantFloodZone;

                // If true, build flood_zone_class by concatenating FLD_ZONE + ZONE_SUBTY + percentage
                if (hasSignificantFloodZone && this.groupedFloodZones && this.groupedFloodZones.length > 0) {
                    const floodZoneClasses = this.groupedFloodZones
                        .filter(group => {
                            // Exclude "X" with "AREA OF MINIMAL FLOOD HAZARD"
                            return !(group.fldZone === 'X' && group.zoneSubty === 'AREA OF MINIMAL FLOOD HAZARD');
                        })
                        .map(group => {
                            // Concatenate FLD_ZONE + ZONE_SUBTY + percentage
                            const parts = [group.fldZone || ''];
                            if (group.zoneSubty) {
                                parts.push(group.zoneSubty);
                            }
                            parts.push(`${group.coveragePercent.toFixed(2)}%`);
                            return parts.join(' ');
                        });

                    if (floodZoneClasses.length > 0) {
                        attributes.flood_zone_class = floodZoneClasses.join(', ');
                    }
                }
            } else {
                // No flood zone data available
                attributes.is_flood_zone = false;
            }

            // Historic flags (from parcelDetails)
            attributes.is_historic = this.parcelDetails.isWithinHistoricDistrict === true;
            attributes.is_wilmington_1945 = this.parcelDetails.isWithinHistoric1945 === true;

            // COMMENTED OUT: Permitted uses are now loaded in C# ChatController as promptUsesAttributes
            // Permitted uses - all 6 types
            // if (this.permittedUses && this.permittedUses.permittedByRight && this.permittedUses.permittedByRight.length > 0) {
            //     attributes.permitted_by_right = this.permittedUses.permittedByRight;
            // }

            // if (this.permittedUses && this.permittedUses.permittedWithSupplemental && this.permittedUses.permittedWithSupplemental.length > 0) {
            //     attributes.permitted_with_supplemental = this.permittedUses.permittedWithSupplemental;
            // }

            // if (this.permittedUses && this.permittedUses.specialUsePermit && this.permittedUses.specialUsePermit.length > 0) {
            //     attributes.special_use_permit = this.permittedUses.specialUsePermit;
            // }

            // if (this.permittedUses && this.permittedUses.specialUsePermitSupplemental && this.permittedUses.specialUsePermitSupplemental.length > 0) {
            //     attributes.special_use_permit_supplemental = this.permittedUses.specialUsePermitSupplemental;
            // }

            // if (this.permittedUses && this.permittedUses.conditionalZoning && this.permittedUses.conditionalZoning.length > 0) {
            //     attributes.conditional_zoning = this.permittedUses.conditionalZoning;
            // }

            // if (this.permittedUses && this.permittedUses.conditionalZoningSupplemental && this.permittedUses.conditionalZoningSupplemental.length > 0) {
            //     attributes.conditional_zoning_supplemental = this.permittedUses.conditionalZoningSupplemental;
            // }

            return attributes;
        },
        closeChatPanel() {
            this.showChatPanel = false;
            this.chatInput = '';
            this.chatResponse = null;
            this.chatLoading = false;
        },
        async submitChat() {
            if (!this.chatInput.trim() || this.chatLoading) {
                return;
            }

            if (this.chatTooLong) {
                return;
            }

            const message = this.chatInput.trim();
            if (!message) return;

            // Clear input immediately
            this.chatInput = '';

            this.chatLoading = true;
            this.chatResponse = null;

            try {
                // Load flood zone data if not already loaded (needed for prompt attributes)
                if (this.floodZoneData === null) {
                    await this.loadFloodZonesForTab();
                }

                // Build prompt attributes from available parcel data
                const promptAttributes = await this.buildPromptAttributes();

                const response = await ApiClient.post('/api/chat/chat', {
                    message,
                    promptAttributes: promptAttributes,
                    municipalityId: this.currentMunicipalityId,
                    stream: true // Enable streaming
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Treat as streaming when a body is present (SSE)
                const contentType = response.headers.get('content-type');
                if (response.body && (!contentType || contentType.includes('text/event-stream'))) {
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    let buffer = '';
                    // Reset displayed response for new stream
                    this.chatResponse = '';
                    this.chatStatus = '';

                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            if (buffer) {
                                const lines = buffer.split('\n');
                                for (const line of lines) {
                                    if (line.startsWith('data: ')) {
                                        const data = line.substring(6);
                                        if (data.trim() === '[DONE]') {
                                            continue;
                                        }
                                        try {
                                            const parsed = JSON.parse(data);
                                            if (parsed.text) {
                                                // Append chunk as it arrives
                                                this.chatResponse = (this.chatResponse || '') + parsed.text;
                                                if (this.chatLoading) {
                                                    this.chatLoading = false; // stop showing spinner once we have data
                                                }
                                                // Clear status when we start receiving text
                                                if (this.chatStatus) {
                                                    this.chatStatus = '';
                                                }
                                            }
                                            if (parsed.status) {
                                                this.chatStatus = parsed.status;
                                                if (this.chatLoading) {
                                                    this.chatLoading = false;
                                                }
                                            }
                                        } catch (e) {
                                            if (!(e instanceof SyntaxError)) {
                                                throw e;
                                            }
                                        }
                                    }
                                }
                            }
                            break;
                        }

                        buffer += decoder.decode(value, { stream: true });
                        const lines = buffer.split('\n');
                        buffer = lines.pop() || '';

                        for (const line of lines) {
                            if (line.startsWith('data: ')) {
                                const data = line.substring(6);

                                if (data.trim() === '[DONE]') {
                                    continue;
                                }

                                try {
                                    const parsed = JSON.parse(data);

                                    if (parsed.error) {
                                        throw new Error(parsed.error);
                                    }

                                    if (parsed.text) {
                                        // Append chunk as it arrives
                                        this.chatResponse = (this.chatResponse || '') + parsed.text;
                                        if (this.chatLoading) {
                                            this.chatLoading = false; // stop showing spinner once we have data
                                        }
                                        // Clear status when we start receiving text
                                        if (this.chatStatus) {
                                            this.chatStatus = '';
                                        }
                                    }
                                    if (parsed.status) {
                                        this.chatStatus = parsed.status;
                                        if (this.chatLoading) {
                                            this.chatLoading = false;
                                        }
                                    }
                                } catch (e) {
                                    if (e instanceof SyntaxError) {
                                        continue;
                                    }
                                    throw e;
                                }
                            }
                        }
                    }
                } else {
                    // Fallback to non-streaming response
                    const data = await response.json();
                    this.chatResponse = data.response || data;
                }
            } catch (error) {
                console.error('Error submitting chat:', error);
                this.chatResponse = { error: 'Failed to get response. Please try again.' };
            } finally {
                this.chatLoading = false;
                // Clear status when done (success or error)
                this.chatStatus = '';
                // Refresh remaining chats count after submission
                if (this.isAuthenticated) {
                    await this.fetchRemainingChats();
                }
            }
        },
        formatChatResponse(response) {
            if (typeof response === 'string') {
                // If it's already a string, try to parse as markdown
                if (typeof marked !== 'undefined') {
                    return marked.parse(response);
                }
                return response;
            }
            if (response.error) {
                return `<div class="chat-error">${response.error}</div>`;
            }
            if (response.response) {
                // Convert markdown to HTML if marked library is available
                if (typeof marked !== 'undefined') {
                    try {
                        return marked.parse(response.response);
                    } catch (e) {
                        console.error('Error parsing markdown:', e);
                        return response.response;
                    }
                }
                return response.response;
            }
            return JSON.stringify(response, null, 2);
        },
        getPermissionClassLabel(permissionClass) {
            const labels = {
                'PBR': 'Permitted by Right',
                'PWS': 'Permitted with Supplemental Standards',
                'SUP': 'Special Use Permit Required',
                'SUPS': 'Special Use Permit + Supplemental Standards',
                'CZ': 'Conditional Zoning Required',
                'CZS': 'Conditional Zoning + Supplemental Standards'
            };
            return labels[permissionClass] || permissionClass;
        },
        async loadPermittedUses() {
            // Don't make API call if not authenticated
            if (!this.isAuthenticated) {
                this.permittedUses = {
                    permittedByRight: [],
                    permittedWithSupplemental: [],
                    specialUsePermit: [],
                    specialUsePermitSupplemental: [],
                    conditionalZoning: [],
                    conditionalZoningSupplemental: []
                };
                return;
            }

            const zoning = this.currentZoningDistrict;
            if (!zoning) {
                this.permittedUses = {
                    permittedByRight: [],
                    permittedWithSupplemental: [],
                    specialUsePermit: [],
                    specialUsePermitSupplemental: [],
                    conditionalZoning: [],
                    conditionalZoningSupplemental: []
                };
                return;
            }

            this.permittedUsesLoading = true;
            try {
                const municipalityId = this.currentMunicipalityId;
                const response = await ApiClient.get(`/api/uses/get-uses-by-zone?zone=${encodeURIComponent(zoning)}&municipalityId=${municipalityId}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                this.permittedUses = {
                    permittedByRight: data.permittedByRight || [],
                    permittedWithSupplemental: data.permittedWithSupplemental || [],
                    specialUsePermit: data.specialUsePermit || [],
                    specialUsePermitSupplemental: data.specialUsePermitSupplemental || [],
                    conditionalZoning: data.conditionalZoning || [],
                    conditionalZoningSupplemental: data.conditionalZoningSupplemental || []
                };
                // Map the new object structure from the API response
                this.permittedResidentialTags = {
                    singleFamily: data.allowsSingleFamily || { allowsSingleFamily: false, permissionClass: '', supplementalRegulation: null },
                    duplex: data.allowsDuplex || { allowsDuplex: false, permissionClass: '', supplementalRegulation: null },
                    triplex: data.allowsTriplex || { allowsTriplex: false, permissionClass: '', supplementalRegulation: null },
                    adu: data.allowsAdu || { allowsAdu: false, permissionClass: '', supplementalRegulation: null },
                    commercial: data.allowsCommercial || { allowsCommercial: false, permissionClass: '', supplementalRegulation: null }
                };
            } catch (err) {
                console.error('Error loading permitted uses:', err);
                this.permittedUses = {
                    permittedByRight: [],
                    permittedWithSupplemental: [],
                    specialUsePermit: [],
                    specialUsePermitSupplemental: [],
                    conditionalZoning: [],
                    conditionalZoningSupplemental: []
                };
            } finally {
                this.permittedUsesLoading = false;
            }
        },
        async loadSetbacks() {
            // Don't make API call if not authenticated
            if (!this.isAuthenticated) {
                return;
            }

            const zoning = this.currentZoningDistrict;
            if (typeof MapInspect !== 'undefined' && MapInspect.loadSetbacks) {
                await MapInspect.loadSetbacks(zoning);
            }
        },
        async loadDevStandards() {
            // Don't make API call if not authenticated
            if (!this.isAuthenticated) {
                return;
            }

            const zoning = this.currentZoningDistrict;
            const municipalityId = this.currentMunicipalityId || 1;
            if (typeof MapInspect !== 'undefined' && MapInspect.loadDevStandards) {
                MapInspect.loadDevStandards(zoning, municipalityId);
            }
        },
        getBaseSetback(type) {
            if (typeof MapInspect !== 'undefined' && MapInspect.getBaseSetback) {
                return MapInspect.getBaseSetback(type);
            }
            return null;
        },
        getCommonSetbacks(type) {
            if (typeof MapInspect !== 'undefined' && MapInspect.getCommonSetbacks) {
                return MapInspect.getCommonSetbacks(type);
            }
            return [];
        },
        getNonCommonSetbacks(type) {
            if (typeof MapInspect !== 'undefined' && MapInspect.getNonCommonSetbacks) {
                return MapInspect.getNonCommonSetbacks(type);
            }
            return [];
        },
        toggleShowMoreSetbacks() {
            if (typeof MapInspect !== 'undefined' && MapInspect.toggleShowMoreSetbacks) {
                MapInspect.toggleShowMoreSetbacks();
            }
        },
        getBaseStandard(category) {
            if (typeof MapInspect !== 'undefined' && MapInspect.getBaseStandard) {
                return MapInspect.getBaseStandard(category);
            }
            return null;
        },
        getNonBaseStandards(category) {
            if (typeof MapInspect !== 'undefined' && MapInspect.getNonBaseStandards) {
                return MapInspect.getNonBaseStandards(category);
            }
            return [];
        },
        getStandardCategories() {
            if (typeof MapInspect !== 'undefined' && MapInspect.getStandardCategories) {
                return MapInspect.getStandardCategories();
            }
            return [];
        },
        hasBaseStandards() {
            if (typeof MapInspect !== 'undefined' && MapInspect.hasBaseStandards) {
                return MapInspect.hasBaseStandards();
            }
            return false;
        },
        formatCategoryName(category) {
            return category.split('_').map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            ).join(' ');
        },
        formatCurrency(value) {
            if (value === null || value === undefined) {
                return '—';
            }
            return new Intl.NumberFormat('en-US').format(value);
        },
        formatFrontage(value) {
            if (value === null || value === undefined) {
                return '—';
            }
            // Format to 1 decimal place and add "ft"
            return `${parseFloat(value).toFixed(1)} ft`;
        },
        formatSquareFeet(value) {
            if (value === null || value === undefined) {
                return '—';
            }
            // Format with commas and add "sq ft"
            return `${new Intl.NumberFormat('en-US').format(Math.round(value))} sq ft`;
        },
        toggleMunicipality(municipalityId) {
            const municipality = this.municipalities.find(m => m.id === municipalityId);
            if (municipality) {
                municipality.collapsed = !municipality.collapsed;
            }
        },
        getLayerForMunicipality(municipalityId) {
            return this.layers.find(layer => layer.municipalityId === municipalityId);
        },
        isZoneActive(municipalityId, zone) {
            return this.activeZones[`${municipalityId}-${zone}`] === true;
        },
        async toggleZone(municipalityId, zone, checked) {
            if (!window.mapInstance || typeof MapLayers === 'undefined') {
                return;
            }

            const zoneKey = `${municipalityId}-${zone}`;

            if (checked) {
                // Show zone polygons
                this.loadingZones[zoneKey] = true;

                // Show loading overlay
                if (window.MapLoading) {
                    MapLoading.show();
                }

                try {
                    await MapLayers.loadZonePolygons(window.mapInstance, municipalityId, zone, zoneKey);
                    this.activeZones[zoneKey] = true;
                } catch (err) {
                    console.error('Error loading zone polygons:', err);
                    alert('Error loading zone polygons');
                } finally {
                    this.loadingZones[zoneKey] = false;

                    // Hide loading overlay
                    if (window.MapLoading) {
                        MapLoading.hide();
                    }
                }
            } else {
                // Hide zone polygons
                if (MapLayers.removeZonePolygons) {
                    MapLayers.removeZonePolygons(window.mapInstance, zoneKey);
                }
                this.activeZones[zoneKey] = false;
            }
        }
    },
    computed: {
        chatCharCount() {
            return this.chatInput ? this.chatInput.length : 0;
        },
        chatTooLong() {
            return this.chatCharCount > this.chatMaxLength;
        },
        isPolygonDrawingActive() {
            // Check the data property first
            if (this.isPolygonDrawing) {
                return true;
            }
            // Fallback: check button class (in case drawing completes normally)
            const btn = document.getElementById('btn-measure-area');
            return btn && btn.classList.contains('active');
        },
        isLineDrawingActive() {
            // Check the data property first
            if (this.isLineDrawing) {
                return true;
            }
            // Fallback: check button class (in case drawing completes normally)
            const btn = document.getElementById('btn-measure-distance');
            return btn && btn.classList.contains('active');
        },
        currentParcel() {
            if (this.parcelRecords && this.parcelRecords.length > 0) {
                return this.parcelRecords[this.selectedParcelIndex] || null;
            }
            return null;
        },
        terrain3DTitle() {
            const base = '3D Terrain View';
            const address = this.inspectionAddress || (this.currentParcel && this.currentParcel.parcelAddress) || null;
            const pid = (this.currentParcel && (this.currentParcel.parcelId || this.currentParcel.pid)) || this.parcelDetails?.pid || null;
            if (address || pid) {
                const parts = [];
                if (address) parts.push(address);
                if (pid) parts.push(`PID ${pid}`);
                return `${base} — ${parts.join(', ')}`;
            }
            return base;
        },
        googleStreetViewUrl() {
            // Get address from inspectionAddress or currentParcel
            const address = this.inspectionAddress || 
                           (this.currentParcel && this.currentParcel.parcelAddress) ||
                           null;
            
            if (address) {
                // Format address for URL: replace spaces with + signs (as per user example)
                // Use encodeURIComponent but then replace %2B back to + to preserve + signs
                const formattedAddress = address.trim().replace(/\s+/g, '+');
                // Encode the address but preserve + signs
                const encodedAddress = encodeURIComponent(formattedAddress).replace(/%2B/g, '+');
                return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
            }
            return null;
        },
        deedUrl() {
            // Only show link if both saleBook and salePage exist
            const saleBook = this.currentParcel && this.currentParcel.saleBook;
            const salePage = this.currentParcel && this.currentParcel.salePage;
            
            if (saleBook !== null && saleBook !== undefined && 
                salePage !== null && salePage !== undefined) {
                // Pad both values to 6 digits with leading zeros
                const paddedBook = String(saleBook).padStart(6, '0');
                const paddedPage = String(salePage).padStart(6, '0');
                return `http://search.newhanoverdeeds.com/view_image.php?file=/img/nc/newhanover/rb/${paddedBook}/${paddedPage}.tif&type=pdf`;
            }
            return null;
        },
        currentZoningDistrict() {
            const parcel = this.currentParcel;
            if (parcel && (parcel.zoning || parcel.zoningDistrict)) {
                return parcel.zoning || parcel.zoningDistrict;
            }
            return this.parcelDetails.zoningDistrict || null;
        },
        udoUrl() {
            const municipalityId = this.currentMunicipalityId;
            const udoUrls = {
                1: 'https://library.municode.com/nc/wilmington/codes/land_development_code', // Wilmington
                2: 'https://library.municode.com/nc/carolina_beach/codes/code_of_ordinances?nodeId=PTIIILADE_APXAUNDEOR', // CB
                3: 'https://codelibrary.amlegal.com/codes/wrightsvillebeach/latest/wright_nc/0-0-0-5536', // WB
                5: 'https://laserfiche.nhcgov.com/WebLink/DocView.aspx?id=5392254&dbid=0&repo=NHC' // NHC
            };
            return udoUrls[municipalityId] || null;
        },
        currentMunicipalityId() {
            const parcel = this.currentParcel;
            // Prefer municipality inferred from the zoning layer / details (set in showInspectionData)
            if (this.parcelDetails && this.parcelDetails.municipalityId) {
                return this.parcelDetails.municipalityId;
            }
            // Fall back to municipality from the currently selected parcel record if present
            if (parcel && parcel.municipalityID !== null && parcel.municipalityID !== undefined) {
                return parcel.municipalityID;
            }
            // Default to 1 (Wilmington) if not available
            return 1;
        },
        isHistoricDistrictEnabled() {
            const layer = this.layers.find(l => l.groupName === 'wilmington-historic');
            return layer ? layer.enabled === true : false;
        },
        isHistoric1945Enabled() {
            const layer = this.layers.find(l => l.groupName === 'wilmington-1945');
            return layer ? layer.enabled === true : false;
        },
        isHeightOverlayEnabled() {
            const layer = this.layers.find(l => l.groupName === 'tocb-heightoverlay');
            return layer ? layer.enabled === true : false;
        },
        chatResetTime() {
            // Calculate the next midnight UTC (when the counter resets)
            const now = new Date();

            // Get today's midnight UTC
            const todayMidnightUtc = new Date(Date.UTC(
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate(),
                0, 0, 0
            ));

            // If we've passed today's midnight UTC, use tomorrow's midnight UTC
            const nextMidnightUtc = now >= todayMidnightUtc
                ? new Date(todayMidnightUtc.getTime() + 24 * 60 * 60 * 1000)
                : todayMidnightUtc;

            // Convert to local time and format
            const localTime = nextMidnightUtc.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZoneName: 'short'
            });

            return localTime;
        },
        hasCheckedUses() {
            const checked = this.usesChecked || {};
            return Object.keys(checked).length > 0;
        },
        hasBaseSetbacks() {
            if (typeof MapInspect !== 'undefined' && MapInspect.hasBaseSetbacks) {
                return MapInspect.hasBaseSetbacks();
            }
            return false;
        },
        hasCommonSetbacks() {
            if (typeof MapInspect !== 'undefined' && MapInspect.hasCommonSetbacks) {
                return MapInspect.hasCommonSetbacks();
            }
            return false;
        },
        isAnyZoningLayerEnabled() {
            // Check if any of the 4 zoning layers are enabled
            const zoningLayerGroupNames = ['towb', 'tocb', 'nhc', 'wilmington'];
            return this.layers.some(layer =>
                zoningLayerGroupNames.includes(layer.groupName) && layer.enabled === true
            );
        },
        groupedFloodZones() {
            if (!this.floodZoneData || !this.floodZoneData.floodZones || this.floodZoneData.floodZones.length === 0) {
                return [];
            }

            // Group by fldZone + zoneSubty combination
            const groups = {};

            this.floodZoneData.floodZones.forEach(zone => {
                const key = `${zone.fldZone || 'Unknown'}_${zone.zoneSubty || 'null'}`;

                if (!groups[key]) {
                    groups[key] = {
                        fldZone: zone.fldZone || 'Unknown',
                        zoneSubty: zone.zoneSubty,
                        coveragePercent: 0,
                        count: 0,
                        staticBfe: zone.staticBfe,
                        vDatum: zone.vDatum
                    };
                }

                groups[key].coveragePercent += zone.coveragePercent || 0;
                groups[key].count += 1;

                // Use the first non-null BFE and datum
                if (!groups[key].staticBfe && zone.staticBfe) {
                    groups[key].staticBfe = zone.staticBfe;
                }
                if (!groups[key].vDatum && zone.vDatum) {
                    groups[key].vDatum = zone.vDatum;
                }
            });

            // Convert to array and round percentages
            return Object.values(groups).map(group => ({
                ...group,
                coveragePercent: Math.round(group.coveragePercent * 100) / 100
            })).sort((a, b) => b.coveragePercent - a.coveragePercent);
        }
    },
    watch: {
        searchAddress(newValue) {
            // Don't trigger search if we're programmatically selecting an address
            if (this.isSelectingAddress) {
                return;
            }

            // Clear existing timer
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }

            // Clear results if input is empty
            if (!newValue || !newValue.trim()) {
                this.searchResults = [];
                return;
            }

            // Set new timer to call fuzzyAddressSearch after 300ms of no typing
            this.searchDebounceTimer = setTimeout(() => {
                if (MapMarkers && MapMarkers.fuzzyAddressSearch) {
                    MapMarkers.fuzzyAddressSearch(newValue).then(results => {
                        this.searchResults = results || [];
                    }).catch(error => {
                        console.error('Fuzzy address search error:', error);
                        this.searchResults = [];
                    });
                }
            }, 300);
        },
        currentParcel(newParcel, oldParcel) {
            // When the selected parcel changes (via parcel tabs), reset flood zone, wetland, and soil data
            // User will need to click the FLOOD ZONE tab to load data
            if (newParcel && this.showInspectionPanel) {
                this.floodZoneData = null;
                this.wetlandData = null;
                this.wetlandDetailsExpanded = {};
                this.soilData = null;
            }
        },
        searchResults(newResults) {
            // Position search results dropdown on mobile
            if (newResults && newResults.length > 0) {
                this.positionSearchResults();
            }
        },
        showInspectionPanel(newValue) {
            // Check tabs scroll when inspection panel is shown
            if (newValue) {
                this.checkTabsScroll();
            }
        },
        isLineDrawing(newValue, oldValue) {
            // Hide alert when line drawing completes on non-mobile (mobile can edit, so keep alert visible)
            if (oldValue === true && newValue === false && this.showLineDrawingAlert && !this.isMobile) {
                this.showLineDrawingAlert = false;
            }
        },
        isPolygonDrawing(newValue, oldValue) {
            // Hide alert when polygon drawing completes
            if (oldValue === true && newValue === false && this.showPolygonDrawingAlert) {
                this.showPolygonDrawingAlert = false;
            }
        }
    },
    async mounted() {
        // Store Vue app instance globally for map initialization
        window.vueAppInstance = this;
        
        // Auto-fade banner after 30 seconds if it's visible
        if (this.showBanner) {
            setTimeout(() => {
                if (this.showBanner) {
                    this.closeBanner();
                }
            }, 20000);
        }

        // Check if we're coming from a login redirect (check URL params)
        const params = new URLSearchParams(window.location.search);
        const isLoginRedirect = params.has('loginSuccess') ||
            document.referrer.includes('/auth/verify-code') ||
            document.referrer.includes('/auth/authenticate');

        // Longer delay after login redirect to ensure session is established
        const delay = isLoginRedirect ? 300 : 50;
        await new Promise(resolve => setTimeout(resolve, delay));

        // Check authentication status first (await to ensure it completes)
        await this.checkAuthStatus();

        // Clean up loginSuccess param if present
        if (params.has('loginSuccess')) {
            params.delete('loginSuccess');
            const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
            window.history.replaceState({}, '', newUrl);
        }

        // Initialize map inspection with Vue app reference
        if (typeof MapInspect !== 'undefined' && window.mapInstance) {
            MapInspect.initialize(window.mapInstance, this);
        }

        // Handle deep-link query params to open auth overlay
        const openReg = params.get('openRegistration');
        const openLoginError = params.get('openLoginError');
        const sessionExpired = params.get('sessionExpired');
        const emailParam = params.get('email') || '';
        const msgParam = params.get('msg') || '';
        const authModeParam = params.get('authMode') || 'login';
        const authStateParam = params.get('authState') || (openReg ? 'register' : 'login');

        if (openReg) {
            this.openRegistration(authModeParam || 'register', msgParam, emailParam, authStateParam || 'register');
        } else if (openLoginError) {
            this.openRegistration('login', msgParam, emailParam, authStateParam || 'login');
        } else if (sessionExpired) {
            this.handleSessionExpired();
        }

        // Clean up URL if access_token is in query string (token is now in cookie)
        if (params.has('access_token')) {
            params.delete('access_token');
            const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
            window.history.replaceState({}, '', newUrl);
        }

        // Handle window resize to reposition search results on mobile and check tabs scroll
        window.addEventListener('resize', () => {
            this.positionSearchResults();
            this.checkTabsScroll();
            // Update mobile detection
            this.isMobile = window.innerWidth <= 576;
        });

        // Handle escape key for global modal
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && this.showGlobalModal) {
                this.closeGlobalModal();
            }
        };
        document.addEventListener('keydown', handleEscapeKey);

        // Initial check for tabs scroll
        this.checkTabsScroll();

        // Expose global modal methods to window for other JS files
        window.openGlobalModal = (content) => {
            this.openGlobalModal(content);
        };
        window.closeGlobalModal = () => {
            this.closeGlobalModal();
        };
        window.openContactModal = () => {
            this.openContactModal();
        };

        // Add event listener for footer contact link as fallback (using event delegation)
        document.addEventListener('click', (e) => {
            if (e.target && (e.target.id === 'contact-us-footer-link' || e.target.closest('#contact-us-footer-link'))) {
                e.preventDefault();
                e.stopPropagation();
                this.openContactModal();
            }
        });
    }
}).mount('#app');